/**
 * Détecte si la ligne formulaire courante diffère de la baseline (BL-0635).
 */
export function u2000IsFormRowDirty(current: unknown, old: unknown): boolean {
  if (current === old) {
    return false;
  }
  if (current == null && old == null) {
    return false;
  }
  if (current == null || old == null) {
    return true;
  }
  return JSON.stringify(current) !== JSON.stringify(old);
}
